module.exports = __webpack_public_path__ + "static/img/pic_titlienrjj@2x.f9ed0cde.png";